import React from 'react';

import { AlertBox, AlertBoxDismissButton } from '@vp/swan';

type MissingContentAlertProps = {};

function MissingContentAlert({}: MissingContentAlertProps): JSX.Element {
  return (
    // TODO: this will need a translation.
    <AlertBox skin="error">
      Whoops – something unexpected just happened.
      <AlertBoxDismissButton accessibleText="Dismiss alert" />
    </AlertBox>
  );
}

export default MissingContentAlert;
